import React, { useState, useEffect } from 'react';

import Api from 'utils/api';

import styles from './ProductBrandTab.module.css';

const ProductBrandTab = () => {
  const [brands, setBrands] = useState([]);
  const [loading, setLoading] = useState(true);

  // 모달 및 폼 상태
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [formData, setFormData] = useState({ productBrandId: null, productBrandName: '' });

  useEffect(() => {
    fetchBrandList();
  }, []);

  // 1. 리스트 조회 (GET)
  const fetchBrandList = async () => {
    setLoading(true);

    const data = await Api.get('/product/brand');
    setBrands(data.productBrandList || []);
    setLoading(false);
  };

  const handleOpenModal = (mode, data = null) => {
    setIsEditMode(mode === 'edit');
    setFormData(data ? { ...data } : { productBrandId: null, productBrandName: '' });
    setIsModalOpen(true);
  };

  // 2. 저장 로직 (POST)
  const handleSave = async () => {
    if (!formData.productBrandName.trim()) {
      return alert("브랜드 이름을 입력해주세요.");
    }

    try {
      let response;

      if (isEditMode) {
        // 수정
        const requestBody = {
          productBrandId: formData.productBrandId,
          productBrandName: formData.productBrandName
        };

        response = await Api.patch('/product/brand', requestBody);

      } else {
        // 등록
        const requestBody = {
          productBrandName: formData.productBrandName
        };

        response = await Api.post('/product/brand', requestBody);
      }

      if (!response) return;

      alert(isEditMode ? "수정이 완료되었습니다." : "등록이 완료되었습니다.");
      setIsModalOpen(false);
      fetchBrandList();

    } catch (error) {
      console.error("통신 오류:", error);
      alert("서버와 통신 중 오류가 발생했습니다.");
    }
  };

  // 3. 삭제 로직 (DELETE)
  const handleDelete = async (id) => {
    if (!window.confirm("이 브랜드를 삭제하시겠습니까?")) return;

    const data = await Api.delete(`/product/brand?productBrandId=${id}`)

    if (data.code === 200) {
      alert("삭제가 완료되었습니다.");
      fetchBrandList(); // 삭제 후 목록 최신화
    } else {
      alert(`삭제 실패: ${data.message || '오류가 발생했습니다.'}`);
    }

  };

  if (loading) return <div className={styles.centerMsg}>브랜드 정보를 불러오는 중...</div>;

  return (
    <div className={styles.container}>
      <div className={styles.topBar}>
        <div className={styles.countInfo}>등록된 브랜드 <span className={styles.countNumber}>{brands.length}</span></div>
        <button className={styles.addBtn} onClick={() => handleOpenModal('add')}>+ 브랜드 등록</button>
      </div>

      <div className={styles.cardGrid}>
        {brands.map((f) => (
          <div key={f.productBrandId} className={styles.productBrandCard}>
            <div className={styles.cardHeader}>
              <div>
                <h3 className={styles.brandName}>{f.productBrandName}</h3>
              </div>
            </div>

            <div className={styles.cardFooter}>
              <button className={styles.editBtn} onClick={() => handleOpenModal('edit', f)}>수정</button>
              <button className={styles.deleteBtn} onClick={() => handleDelete(f.productBrandId)}>삭제</button>
            </div>
          </div>
        ))}
      </div>

      {isModalOpen && (
        <div className={styles.modalOverlay}>
          <div className={styles.modalContent}>
            <div className={styles.modalHeader}>
              <h3>{isEditMode ? '브랜드 수정' : '새 브랜드 등록'}</h3>
              <button className={styles.closeBtn} onClick={() => setIsModalOpen(false)}>✕</button>
            </div>
            <div className={styles.modalBody}>
              <div className={styles.formContainer}>
                <div className={styles.inputGroup}>
                  <label>브랜드 명칭</label>
                  <input
                    name="productBrandName"
                    value={formData.productBrandName}
                    onChange={(e) => setFormData({ ...formData, productBrandName: e.target.value })}
                    className={styles.modalInput}
                    autoFocus
                  />
                </div>
              </div>
            </div>
            <div className={styles.modalFooter}>
              <button className={styles.cancelBtn} onClick={() => setIsModalOpen(false)}>취소</button>
              <button className={styles.saveBtn} onClick={handleSave}>저장하기</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ProductBrandTab;